import {defineNuxtRouteMiddleware, useNuxtApp} from '#app';
import {useGuestHost, useAuth} from '#imports';
import {safelyNavigateTo} from '@malt/utils';

export default defineNuxtRouteMiddleware(async () => {
    const nuxtApp = useNuxtApp();
    const store = useAuth(nuxtApp.$pinia);
    const host = useGuestHost();

    const isLogged = await store.isLogged();

    if (isLogged) {
        const path = store.currentIdentityIsClient
            ? '/project-client/find-freelancers'
            : store.currentIdentityIsFreelance
              ? '/dashboard/freelancer'
              : store.currentIdentityIsSubcontractor
                ? 'freelancer/company'
                : '/account/membership';
        return await safelyNavigateTo(`${host}${path}`, {replace: true, externalToThisApp: true});
    }
});
